import React from "react";
import PropTypes from "prop-types";
import Humanize from "humanize-plus";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => ({
  statusDanger: theme.palette.error,
  statusPrimary: theme.palette.primary,
  statusSecondary: theme.palette.secondary,
  // statusSuccess: theme.palette.success,
  // statusWarning: theme.palette.warning,
  // statusDangerDisabled: theme.palette.dangerDisabled,
  statusPrimaryDisabled: theme.palette.primaryDisabled,
  statusSuccessDisabled: theme.palette.successDisabled,
  // statusWarningDisabled: theme.palette.warningDisabled,

  textVariantOverride: {
    border: "none",
    background: "none",
    "&:hover": {
      background: "none"
    }
  },
  disablePadding: {
    padding: 0
  }
}));

const OSSButton = ({
  children,
  className,
  disabled,
  onClick,
  status,
  variant,
  disablePadding,
  ...rest
}) => {
  const classes = useStyles();

  function getButtonClass() {
    var buttonClass = status
      ? classes[`status${Humanize.capitalize(status)}`]
      : "";

    return buttonClass;
  }

  function getDisabledClass() {
    var disabledClass = status
      ? classes[`status${Humanize.capitalize(status)}Disabled`]
      : "";

    return disabledClass;
  }

  return (
    <Button
      classes={{
        root: getButtonClass(),
        disabled: getDisabledClass()
        // text: variant === "text" ? classes.textVariantOverride : ""
      }}
      className={[className, disablePadding ? classes.disablePadding : ""].join(
        " "
      )}
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      {...rest}
    >
      {children}
    </Button>
  );
};

OSSButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  background: PropTypes.bool,
  status: PropTypes.oneOf([
    "",
    "danger",
    "primary",
    "secondary",
    "success",
    "warning"
  ]),
  onClick: PropTypes.func,
  variant: PropTypes.string,
  disablePadding: PropTypes.bool
};
OSSButton.defaultProps = {
  disabled: false,
  onClick: () => null,
  status: "",
  variant: "contained",
  disablePadding: false
};

export default OSSButton;
